
import Vue from 'vue'

import 'src/assets/iconfont'
import iconFont from 'src/components/iconFont'
import Single from 'src/components/imageUpload/single.vue'
import Multiple from 'src/components/imageUpload/multiple.vue'
import File from 'src/components/imageUpload/file.vue'

// IconFont
Vue.component('Icon', iconFont)
// 单图片上传
Vue.component('Single', Single)
// 多图上传
Vue.component('Multiple', Multiple)
// 文件上传
Vue.component('File', File)
